import {
  CompanyDebitProcessType,
  ETxnSpeed,
  schemes,
  zSchema,
} from "@zeal/common";

const preprocessSchema = zSchema.object({
  // This is optional due to the automation from crusher.
  filters: zSchema
    .array(
      zSchema.object({
        check_date: schemes.isoDate(),
        company_id: schemes.companyID(),
        speed: zSchema.nativeEnum(ETxnSpeed),
      })
    )
    .optional(),
  type: zSchema.literal(CompanyDebitProcessType.Preprocess),
});

const processSchema = zSchema.object({
  // This is optional due to the automation from crusher.
  filters: zSchema
    .array(
      zSchema.object({
        contractor_payment_group_id: schemes.uuid().optional(),
        company_id: schemes.companyID(),
        employer_check_id: schemes.mongoObjectId().optional(),
      })
    )
    .optional(),
  type: zSchema.literal(CompanyDebitProcessType.Process),
});

const rePreprocessSchema = zSchema.object({
  check_ids: zSchema.array(schemes.uuid()),
  type: zSchema.literal(CompanyDebitProcessType.RePreprocess),
});

export const postCompanyDebitsRequestSchema = zSchema
  .discriminatedUnion("type", [
    preprocessSchema,
    processSchema,
    rePreprocessSchema,
  ])
  .and(
    zSchema.object({
      test: zSchema.boolean(),
    })
  );

export type TPostCompanyDebitsRequestSchema = zSchema.infer<
  typeof postCompanyDebitsRequestSchema
>;

export const postCompanyDebitsResponseSchema = zSchema.array(
  zSchema.object({
    job_id: zSchema.string(),
  })
);

export type TPostCompanyDebitsResponseSchema = zSchema.infer<
  typeof postCompanyDebitsResponseSchema
>;
